module.exports = __webpack_public_path__ + "static/thumb-ondemand-b6f091b344ea81a0e0273a313524be1d.png";